import { writable } from 'svelte/store'

const month = writable({
  current: new Date().toISOString().slice(0, 7),
  infer: (m) => {
    let year = m.slice(0, 4);
    let month_ = m.slice(5);

    switch (month_) {
      case "01": return `Janvier ${year}`;
      case "02": return `Fevrier ${year}`;
      case "03": return `Mars ${year}`;
      case "04": return `Avril ${year}`;
      case "05": return `Mai ${year}`;
      case "06": return `Juin ${year}`;
      case "07": return `Juillet ${year}`;
      case "08": return `Aout ${year}`;
      case "09": return `Septembre ${year}`;
      case "10": return `Octobre ${year}`;
      case "11": return `Novembre ${year}`;
      case "12": return `Decembre ${year}`;
    }
  },
  inferNoYear: (m) => {
    switch (m) {
      case "01": return "Janvier";
      case "02": return "Fevrier";
      case "03": return "Mars";
      case "04": return "Avril";
      case "05": return "Mai";
      case "06": return "Juin";
      case "07": return "Juillet";
      case "08": return "Aout";
      case "09": return "Septembre";
      case "10": return "Octobre";
      case "11": return "Novembre";
      case "12": return "Decembre";
    }
  },
  defer: (m) => {
    switch (m) {
      case "Janvier": return "01";
      case "Fevrier": return "02";
      case "Mars": return "03";
      case "Avril": return "04";
      case "Mai": return "05";
      case "Juin": return "06";
      case "Juillet": return "07";
      case "Aout": return "08";
      case "Septembre": return "09";
      case "Octobre": return "10";
      case "Novembre": return "11";
      case "Decembre": return "12";
    }
  }
});

export default month;